/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Expand_SummaryInputs */

const en_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand your summary to 2-4 sentences for better ATS matching`)
};

const de_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweitere deine Zusammenfassung auf 2-4 Sätze für besseres ATS-Matching`)
};

const fr_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développez votre résumé en 2-4 phrases pour un meilleur matching ATS`)
};

const es_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amplía tu resumen a 2-4 oraciones para una mejor coincidencia ATS`)
};

const it_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandi il tuo riepilogo a 2-4 frasi per un migliore matching ATS`)
};

const nl_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breid je samenvatting uit naar 2-4 zinnen voor betere ATS-matching`)
};

const pl_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozszerz podsumowanie do 2-4 zdań dla lepszego dopasowania ATS`)
};

const fi_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laajenna yhteenvetosi 2-4 lauseeseen parempaa ATS-vastaavuutta varten`)
};

const da_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udvid dit resumé til 2-4 sætninger for bedre ATS-matching`)
};

const sv_ats_tip_expand_summary = /** @type {(inputs: Ats_Tip_Expand_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utöka din sammanfattning till 2-4 meningar för bättre ATS-matchning`)
};

/**
* | output |
* | --- |
* | "Expand your summary to 2-4 sentences for better ATS matching" |
*
* @param {Ats_Tip_Expand_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_expand_summary = /** @type {((inputs?: Ats_Tip_Expand_SummaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Expand_SummaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_expand_summary(inputs)
	if (locale === "fr") return fr_ats_tip_expand_summary(inputs)
	if (locale === "es") return es_ats_tip_expand_summary(inputs)
	if (locale === "it") return it_ats_tip_expand_summary(inputs)
	if (locale === "nl") return nl_ats_tip_expand_summary(inputs)
	if (locale === "pl") return pl_ats_tip_expand_summary(inputs)
	if (locale === "fi") return fi_ats_tip_expand_summary(inputs)
	if (locale === "da") return da_ats_tip_expand_summary(inputs)
	if (locale === "sv") return sv_ats_tip_expand_summary(inputs)
	return en_ats_tip_expand_summary(inputs)
});